module.exports = __webpack_public_path__ + "favicon.png?5c869610b65ae9d7607cad828dd25249";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicons/favicon.png
// module id = 26
// module chunks = 0